import type { EngForm } from "../submissions/schema";
import { activeLabels, LIST_TITLES, type FormLists, type ListKind } from "./types";

// The problems with a form's Feature, Business unit and Pricing plan, against what is on offer now. Used by the server and by the form in the browser.
export function checkFormValues(form: Pick<EngForm, "businessUnit" | "pricingPlan" | "feature">, lists: FormLists): { path: string; message: string }[] {
  const issues: { path: string; message: string }[] = [];
  const check = (path: string, value: string | undefined, kind: ListKind): void => {
    if (value !== undefined && !activeLabels(lists[kind]).includes(value)) {
      issues.push({ path, message: `"${value}" is not offered any more. Choose another ${LIST_TITLES[kind].toLowerCase()}` });
    }
  };
  check("businessUnit", form.businessUnit, "businessUnits");
  check("pricingPlan", form.pricingPlan, "pricingPlans");
  check("feature", form.feature, "features");
  return issues;
}
